import ConfigManager from "@/config/ConfigManager"
import Utility from "@/helper/Utility"

export const PlaceModel = function (obj = null) {
    this.name = null
    this.id = null
    this.location = null
    this.isBuzzeBeesPlace = null
    this.rank = null
    this.buzz = null
    this.like = null
    this.description = null
    this.services = null
    this.contact_number = null
    this.working_day = null
    this.name_en = null
    this.description_en = null
    this.working_day_en = null
    this.address = null
    this.address_en = null
    this.image_url = null
    this.region = null
    this.region_en = null
    this.LineChannelID = null
    this.Category = null
    this.Website = null
    this.reference_code = null
    this.subdistrict_code = null
    this.district_code = null
    this.province_code = null
    this.expert = null
    this.recommended = null
    this.truck_garage = null

    if (obj != null) {
        this.setValues(obj)
    }
}

PlaceModel.prototype.generateImg = function () {
    if (this.image_url == null) {
        this.image_url = ConfigManager.getBlobUrl() + "/locations/" + this.id
    }
}

PlaceModel.prototype.setValues = function (obj) {
    Object.keys(obj).forEach((key) => {
        this[key] = obj[key]
    })
    this.generateImg()
    return this
}

PlaceModel.prototype.saveCache = function () {
    let json = JSON.stringify(this)
    sessionStorage.setItem("search.place.detail", json)

    return this
}

PlaceModel.prototype.loadCache = function () {
    let raw = sessionStorage.getItem("search.place.detail")
    if (!Utility.isEmptyStr(raw)) {
        let json = JSON.parse(raw)
        Object.keys(json).forEach((key) => {
            this[key] = json?.[key]
        })
        this.generateImg()
    }

    return this
}

PlaceModel.prototype.clearCache = function () {
    sessionStorage.removeItem("search.place.detail")

    return this
}

export default PlaceModel

